import React from 'react';

import { OtherGatewayIntegrationProvider } from '@helpers/hooks/pages/dashboard/integrationCenter/gateway/useOtherGatewayIntegration';

import Wrapper from '@components/Dashboard/IntegrationCenter/Sidemodal/Gateway/PredefinedGateways/Cielo';

const Cielo: React.FC = () => {
  return (
    <OtherGatewayIntegrationProvider>
      <Wrapper />
    </OtherGatewayIntegrationProvider>
  );
};

export default Cielo;
